import { useMemo, useState } from "react";
import { PlatformApiError } from "./api";
import { SupportApiClient } from "./support-api";
import type { OrganizationContext, ShellContext } from "./types";

export function SupportModeBanner({ context, organization }: { context: ShellContext; organization?: OrganizationContext }) {
  const api = useMemo(() => new SupportApiClient(fetch), []);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const session = context.supportSession;
  if (!session) return null;

  const selected = organization?.organization
    ?? context.organizations.find(({ organization: candidate }) => candidate.id === session.organizationId)?.organization;
  const name = selected?.displayName ?? "cliente";

  async function exit() {
    setBusy(true);
    setError(null);
    try {
      await api.end();
      window.location.assign(session!.returnTo || "/crm");
    } catch (cause) {
      if (cause instanceof PlatformApiError && cause.status === 401) {
        window.location.reload();
        return;
      }
      setError(cause instanceof Error ? cause.message : "No se pudo salir del modo soporte.");
      setBusy(false);
    }
  }

  return <aside className="support-mode-banner" aria-label="Modo soporte" role="status">
    <div>
      <strong>Modo soporte · {name}</strong>
      <span>Vista cliente de solo lectura · rol {session.effectiveRole.replace("_", " ")}</span>
      {error && <small role="alert">{error}</small>}
    </div>
    <button type="button" disabled={busy} onClick={() => void exit()}>{busy ? "Saliendo…" : "Salir y volver al CRM"}</button>
  </aside>;
}
